export const CloseIconLight = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.94982 7.99935L13.1364 3.81276C13.3061 3.64305 13.3723 3.39572 13.3103 3.1639C13.2482 2.93213 13.0671 2.75103 12.8353 2.6889C12.6034 2.62684 12.3561 2.69306 12.1864 2.86278L7.99984 7.04936L3.81325 2.86278C3.64353 2.69306 3.39621 2.62684 3.16438 2.6889C2.93262 2.75102 2.75152 2.93213 2.68938 3.1639C2.62733 3.39574 2.69355 3.64305 2.86326 3.81276L7.04985 7.99935L2.86326 12.1859C2.69355 12.3557 2.62733 12.603 2.68938 12.8348C2.75151 13.0666 2.93262 13.2477 3.16438 13.3098C3.39623 13.3719 3.64354 13.3056 3.81325 13.1359L7.99984 8.94933L12.1864 13.1359C12.3561 13.3056 12.6035 13.3719 12.8353 13.3098C13.0671 13.2477 13.2482 13.0666 13.3103 12.8348C13.3723 12.603 13.3061 12.3556 13.1364 12.1859L8.94982 7.99935Z"
        fill="#99A0AE"
      />
    </svg>
  );
};
